export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "bugbet-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "bugbet-themeWrap" */'./ThemeImporter'),
  },
};
